import {
  ToolsTableContent,
  ToolsTableContentProps,
} from '@/pages/DocumentPage/components/ToolsTableContent'
import { flattenToolPages, useListToolsQuery } from '@/services/queries/tools'
import { Loading } from '@/components/ui/loading'
import { useMemo } from 'react'

type ToolsTableProps = Omit<ToolsTableContentProps, 'tools'>

export const ToolsTable = (props: ToolsTableProps) => {
  const { data: allToolsData, isLoading: isAllToolsLoading } =
    useListToolsQuery({
      limit: 100,
      offset: 0,
    })
  const { data: documentVersionToolsData, isLoading: isDocumentToolsLoading } =
    useListToolsQuery({
      limit: 100,
      offset: 0,
      documentVersionId: props.documentPage.document_version as string,
    })
  const tools = useMemo(() => flattenToolPages(allToolsData), [allToolsData])
  const documentVersionToolIds = useMemo(
    () =>
      new Set(
        flattenToolPages(documentVersionToolsData).map((tool) => tool.id),
      ),
    [documentVersionToolsData],
  )

  /**
   * Keep table interactions stable by waiting for both datasets:
   * - full org tools for dropdown search
   * - document-version tools for in-scope validity checks
   */
  if (isAllToolsLoading || isDocumentToolsLoading) {
    return <Loading />
  }

  return (
    <ToolsTableContent
      {...props}
      tools={tools}
      documentVersionToolIds={documentVersionToolIds}
    />
  )
}
